/* eslint-disable react/prop-types */ // TODO: add props
import styles from './styles.scss';

const Tick = ({ selected, onClick, disabled }) => {
  if (selected) {
    return (
      <div
        className={styles.option}
        data-test="checklist-tick-selected"
        data-testid="checklist-tick-selected"
      >
        <span className={styles.tickSelected} />
      </div>
    );
  }

  return (
    <div
      className={styles.option}
      onClick={!disabled ? onClick : null}
      data-test="checklist-tick"
      data-testid="checklist-tick"
      role="button"
    >
      <span className={styles.tick} />
    </div>
  );
};

Tick.defaultProps = {
  selected: true,
  disabled: false,
};

export default Tick;
